export default {
  // namespaced: true,
  state: {
    meetMain: {
      token: null,
      viewport: null
    }
  },
  mutations: {
    SET_MEET_MAIN (store, data) {
      store.meetMain = data
    }
  },
  getters: {
    getMeetMain: (store, getters) => {
      return store.meetMain
    }
  },
  actions: {
    setMeetMain ({commit, dispatch, getters, state}, data) {
      commit('SET_MEET_MAIN', {
        token: data.token,
        viewport: data.viewport ? data.viewport : 'divided'
      })
      return data
    },
    updateMeetMain ({commit, dispatch, getters, state}, data) {
      commit('SET_MEET_MAIN', {
        token: state.meetMain.token,
        viewport: data.viewport
      })
      return data
    },
    unsetMeetMain ({commit, dispatch, getters, state}, data) {
      commit('SET_MEET_MAIN', {
        token: null,
        viewport: null
      })
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/MeetMain.js